import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Avatar from '@material-ui/core/Avatar'
import RemoveIcon from '@material-ui/icons/DeleteForever'
import InputIcon from '@material-ui/icons/Input'
import red from '@material-ui/core/colors/red'
import green from '@material-ui/core/colors/green'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Grid from '@material-ui/core/Grid'
import { getPaymentIcon } from 'utils/iconMatcher'
import { withStyles } from '@material-ui/core/styles'
const styles = theme => ({
  rootPaper: {
    flexGrow: 1,
    borderRadius: 5,
    width: '100%',
    backgroundColor: theme.palette.grey['100']
  },
  avatar: {
    margin: 10,
    backgroundColor: theme.palette.primary.main
  },
  topGrid: {
    paddingTop: '0 !important',
    paddingBottom: '0 !important'
  },
  appBar: {
    borderRadius: 5
  },
  appBarTips: {
    borderRadius: 5,
    backgroundColor: green[500]
  },
  title: {
    lineHeight: '40px',
    flex: 1
  },
  itemPaper: {
    height: 'calc(100%)',
    marginBottom: 5,
    borderRadius: 5
  },
  leftTypo: {
    paddingLeft: theme.spacing.unit
  },
  paymentTitleGrid: {
    flexGrow: 1
  },
  removeButton: {
    color: 'white',
    backgroundColor: red[500],
    '&:hover': {
      backgroundColor: red[700]
    }
  },
  buttonProgress: {
    color: theme.palette.primary.main,
    position: 'absolute',
    top: -3,
    left: -3,
    zIndex: 1
  },
  rightItem: {
    paddingRight: theme.spacing.unit
  }
})
class DueComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    payments: PropTypes.array.isRequired,
    onRestClick: PropTypes.func.isRequired,
    removePayment: PropTypes.func.isRequired,
    due: PropTypes.number
  }
  handleRestClicked = e => {
    this.props.onRestClick(this.props.due)
  }
  handleRemoveClick = payment => {
    this.props.removePayment(payment)
  }
  render() {
    const { classes, due, payments } = this.props
    const rest = due < 0 ? 0 : due
    let appBarTitle = 'Reste à payer'
    let appBarTotal = `${Number(rest).toFixed(2)} €`
    let appBarClass = rest > 0 ? classes.appBar : classes.appBarTips
    if (due < 0) {
      appBarTitle = 'Pourboire'
      appBarTotal = Math.abs(due).toFixed(2)
    }
    return (
      <Paper elevation={3} className={classes.rootPaper}>
        <Grid
          container
          direction="row"
          alignItems="flex-start"
          justify="center"
          spacing={16}>
          <Grid className={classes.topGrid} item xs={12}>
            <AppBar elevation={1} className={appBarClass} position="static">
              <Toolbar>
                {due > 0 && (
                  <IconButton
                    onClick={this.handleRestClicked}
                    className={classes.menuButton}
                    color="inherit"
                    aria-label="Ajouter le reste">
                    <InputIcon />
                  </IconButton>
                )}
                <Typography
                  className={classes.title}
                  variant="title"
                  color="inherit">
                  {appBarTitle}
                </Typography>
                <Typography variant="title" color="inherit">
                  {appBarTotal}
                </Typography>
              </Toolbar>
            </AppBar>
          </Grid>
          {payments.length > 0 && (
            <Grid item xs={11}>
              {payments.map((p, i) => {
                const icon = getPaymentIcon(p.type)
                return (
                  <Paper key={p.key} className={classes.itemPaper}>
                    <Grid
                      container
                      direction="row"
                      justify="space-between"
                      alignItems="center"
                      spacing={0}>
                      <Grid item>
                        <Avatar className={classes.avatar}>{icon}</Avatar>
                      </Grid>
                      <Grid className={classes.paymentTitleGrid} item>
                        <Typography
                          className={classes.leftTypo}
                          variant="subheading">
                          {`${p.type} - ${Number(p.amount).toFixed(2)} €`}
                        </Typography>
                      </Grid>
                      <Grid className={classes.rightItem} item>
                        <Button
                          className={classes.removeButton}
                          elevation={1}
                          variant="fab"
                          mini
                          color="inherit"
                          disabled={!p.payment_detail_id}
                          onClick={e => this.handleRemoveClick(p)}>
                          <RemoveIcon color="inherit" />
                          {!p.payment_detail_id && (
                            <CircularProgress
                              size={45}
                              className={classes.buttonProgress}
                            />
                          )}
                        </Button>
                      </Grid>
                    </Grid>
                  </Paper>
                )
              })}
            </Grid>
          )}
        </Grid>
      </Paper>
    )
  }
}

export default withStyles(styles)(DueComponent)



// WEBPACK FOOTER //
// ./src/components/payment/DueComponent.js